import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';

import { TranslationKeyMap } from '../../scorecard.i18n';
import {
    RankFilter,
    ScorecardPublishStatusFilter,
} from '../scorecard-trend-chart/scorecard-trend-chart.model';

@Component({
    selector: 'sc-rank-and-scorecard-published-status-filter',
    templateUrl:
        './sc-rank-and-scorecard-published-status-filter.component.html',
    host: {
        class: 'sc-rank-and-scorecard-published-status-filter',
    },
})
export class ScRankAndScorecardPublishedStatusFilterComponent
    implements OnDestroy
{
    @Input() ranksFilter: RankFilter[];

    // eslint-disable-next-line accessor-pairs
    @Input()
    set scorecardPublishedStatusFilter(value: ScorecardPublishStatusFilter[]) {
        this._scorecardPublishedStatusFilter = value;
        this._visibleScorecardStatusFilter = this
            ._scorecardPublishedStatusFilter
            ? this._scorecardPublishedStatusFilter.filter((x) => x.isVisible)
            : [];
    }

    /** @private */ _scorecardPublishedStatusFilter: ScorecardPublishStatusFilter[];
    /** @private */ _visibleScorecardStatusFilter: ScorecardPublishStatusFilter[];

    @Output() ranksFilterChange: EventEmitter<RankFilter[]>;
    @Output() scorecardPublishedStatusFilterChange: EventEmitter<
        ScorecardPublishStatusFilter[]
    >;

    /** @private */ _i18n = TranslationKeyMap;

    constructor() {
        this.ranksFilterChange = new EventEmitter();
        this.scorecardPublishedStatusFilterChange = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.ranksFilterChange.complete();
        this.scorecardPublishedStatusFilterChange.complete();
    }

    /** @private */ _onRankSelectionChange(rankFilter: RankFilter): void {
        rankFilter.isSelected = !rankFilter.isSelected;
        this.ranksFilterChange.emit(this.ranksFilter);
    }

    /** @private */ _onScorecardStatusSelectionChange(
        scorecardStatus: ScorecardPublishStatusFilter,
    ): void {
        const status = this._scorecardPublishedStatusFilter.find(
            (x) => x.isPublished === scorecardStatus.isPublished,
        );
        status.isSelected = !status.isSelected;
        // eslint-disable-next-line no-return-assign
        this._scorecardPublishedStatusFilter.forEach(
            (x) => (x.canBeDeselected = true),
        );
        const remainingSelected = this._scorecardPublishedStatusFilter.filter(
            (x) => x.isSelected,
        );
        if (remainingSelected.length === 1) {
            remainingSelected[0].canBeDeselected = false;
        }
        this._visibleScorecardStatusFilter =
            this._scorecardPublishedStatusFilter.filter((x) => x.isVisible);
        this.scorecardPublishedStatusFilterChange.emit(
            this._scorecardPublishedStatusFilter,
        );
    }
}
